<div>
  <div class="flex justify-content-center">
    <input
      [(ngModel)]="aliasFilter"
      [placeholder]="'search.byAlias' | transloco"
      [disabled]="loading"
      [focus]="!loading"
      pInputText
      appAutoFocus
      class="mt-1"
      type="search"
    >
  </div>
  <div class="p-2 mt-3">
    <ng-container *ngIf="loading">
      <div class="grid">
        <div class="p-2 pb-0 col-12 md:col-6 lg:col-4 xl:col-2" *ngFor="let _ of [].constructor(numberOfAssets)">
          <div class="w-full asset-card cursor-wait flex">
            <div class="flex" style="width: 45px;">
              <p-skeleton class="w-full" width="45px" height="41.979px"></p-skeleton>
            </div>
            <div class="flex flex-column gap-1" style="width: calc(100% - 45px);">
              <p-skeleton class="pl-3 w-12" width="100%" height="18.99px"></p-skeleton>
              <p-skeleton class="pl-3 w-12" width="100%" height="18.99px"></p-skeleton>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!loading">
      <div class="grid" *ngIf="filteredAssetsWithIcon.length > 0">
        <div class="p-2 pb-0 col-12 md:col-6 lg:col-4 xl:col-2" *ngFor="let assetIcon of filteredAssetsWithIcon">
          <div class="w-full asset-card flex" (click)="onAssetSelected.emit(assetIcon.uuid)">
            <div class="flex" style="width: 45px;">
              <img
                class="align-self-center"
                width="40"
                height="40"
                alt="Icon"
                [src]="'data:image/png;base64,' + (mapIconsService.getIcon(assetIcon.getIdentifier()) ?? assetIcon.icon ?? mapIconsService.getNewDefaultIcon())"
              >
            </div>
            <div class="flex flex-column" style="width: calc(100% - 45px);">
              <p class="pl-3 mb-0 bold white-space-nowrap overflow-hidden text-overflow-ellipsis w-12">
                {{assetIcon.alias}}
              </p>
              <p class="pl-3 white-space-nowrap overflow-hidden text-overflow-ellipsis w-12">
                {{assetIcon.description ? assetIcon.description : ('empty.description' | transloco)}}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="filteredAssetsWithIcon.length == 0" class="text-center">
        <p>{{'misc.noAssetsFoundSearch' | transloco}}</p>
      </div>
    </ng-container>
  </div>
</div>
